<template>
    <div>
        Fork this project or contribute on <a href="https://github.com/Naouak/marvel-lcg-randomizer" target="_blank">Github</a>.
    </div>
</template>

<script>
    export default {
        name: "ContributeText"
    }
</script>

<style scoped>

</style>